import { render, staticRenderFns } from "./ProfileBlocked.vue?vue&type=template&id=d246d5ea&"
import script from "./ProfileBlocked.vue?vue&type=script&lang=js&"
export * from "./ProfileBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports